import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33a883bd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=33a883bd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a883bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\huixin\\云商\\V12_saas版\\erp-flexible-web21-cloud-saas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a883bd')) {
      api.createRecord('33a883bd', component.options)
    } else {
      api.reload('33a883bd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=33a883bd&scoped=true", function () {
      api.rerender('33a883bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tag/index.vue"
export default component.exports